import { patientFormBaseModel } from './crud';

export * from './types';
export * from './usePatientFormMedicationSearch';

export const usePatientFormsById = patientFormBaseModel.fetchById();
export const usePatientFormsByIds = patientFormBaseModel.fetchByIds();
export const usePatientFormsMany = patientFormBaseModel.fetchMany();
export const usePatientFormsCount = patientFormBaseModel.count();
export const usePatientFormsPagination = patientFormBaseModel.fetchPaginated();
export const usePatientFormsUpdateOne = patientFormBaseModel.edit();
export const usePatientFormsCreateOne = patientFormBaseModel.create();
export const usePatientFormsRemoveOne = patientFormBaseModel.delete();
export const usePatientFormsRemoveByIds = patientFormBaseModel.deleteByIds();

export const usePatientFormsByIdV2 = patientFormBaseModel.fetchByIdV2();
export const usePatientFormsByIdsV2 = patientFormBaseModel.fetchByIdsV2();
export const usePatientFormsManyV2 = patientFormBaseModel.fetchManyV2();
export const usePatientFormsManyByContentRangeV2 =
  patientFormBaseModel.fetchManyByContentRangeV2();
export const usePatientFormsCountV2 = patientFormBaseModel.countV2();
export const usePatientFormsPaginationV2 =
  patientFormBaseModel.fetchPaginatedV2();
export const usePatientFormsUpdateOneV2 = patientFormBaseModel.editV2();
export const usePatientFormsCreateOneV2 = patientFormBaseModel.createV2();
export const usePatientFormsRemoveOneV2 = patientFormBaseModel.deleteV2();
export const usePatientFormsRemoveByIdsV2 =
  patientFormBaseModel.deleteByIdsV2();
